import React, { Component } from "react";
import { generic_get_api, generic_post_api, generic_delete_api, generic_patch_api } from "api/generic_api";
import { SKU_METADATA_LIST, SKU_METADATA, SKU_CATEGORIES } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { Placeholder, Modal } from 'react-bootstrap';

class SkuMetadataList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sku_list: [],
            filtered_sku_list: [],
            search_string: '',
            loading: true,
            status_filter: 'active',
            selected_categories: SKU_CATEGORIES.map(c => c.value),
            show_category_dropdown: false,
            show_full_product_name: false,
            show_add_sku_modal: false,
            add_sku_submitting: false,
            show_success_modal: false,
            show_delete_modal: false,
            delete_sku: null,
            deleting: false,
            show_add_data_modal: false,
            add_data_submitting: false,
            add_data_sku: null,
            new_sku: {
                seller_sku: '',
                category: '',
                cost: '',
                is_active: true,
                fn_sku: '',
                asin: '',
                product_name: '',
                comment: '',
            },
        };
    }

    fetchSkuList() {
        this.setState({ loading: true });

        generic_get_api(SKU_METADATA_LIST, { seller_id: 'SELF' })
        .then(
            data => {
                const filtered = this.filterByStatus(data, this.state.status_filter)
                    .filter(sku => this.state.selected_categories.includes(sku.category));
                this.setState({
                    sku_list: data,
                    filtered_sku_list: filtered,
                    loading: false,
                });
            }
        )
        .catch(error => {
            this.setState({ loading: false });
        });
    }

    filterByStatus(list, status_filter) {
        if (status_filter === 'active') return list.filter(sku => sku.is_active);
        if (status_filter === 'inactive') return list.filter(sku => !sku.is_active);
        return list;
    }

    applyFilters(search_string = this.state.search_string, status_filter = this.state.status_filter, selected_categories = this.state.selected_categories) {
        const lower = search_string.toLowerCase();
        const filtered = this.filterByStatus(this.state.sku_list, status_filter).filter(sku => {
            if (!selected_categories.includes(sku.category)) return false;
            return (sku.seller_sku && sku.seller_sku.toLowerCase().includes(lower)) ||
                   (sku.product_name && sku.product_name.toLowerCase().includes(lower));
        });
        this.setState({ search_string, status_filter, selected_categories, filtered_sku_list: filtered });
    }

    toggleCategory(value) {
        const { selected_categories } = this.state;
        const updated = selected_categories.includes(value)
            ? selected_categories.filter(c => c !== value)
            : [...selected_categories, value];
        this.applyFilters(undefined, undefined, updated);
    }

    toggleAllCategories() {
        const all = SKU_CATEGORIES.map(c => c.value);
        const allSelected = this.state.selected_categories.length === SKU_CATEGORIES.length;
        this.applyFilters(undefined, undefined, allSelected ? [] : all);
    }

    openAddSkuModal() {
        this.setState({
            show_add_sku_modal: true,
            new_sku: {
                seller_sku: '',
                category: '',
                cost: '',
                is_active: true,
                fn_sku: '',
                asin: '',
                product_name: '',
                comment: '',
            },
        });
    }

    closeAddSkuModal() {
        this.setState({ show_add_sku_modal: false });
    }

    updateNewSkuField(field, value) {
        this.setState({ new_sku: { ...this.state.new_sku, [field]: value } });
    }

    submitAddSku() {
        const { new_sku } = this.state;

        if (!new_sku.seller_sku || !new_sku.category || !new_sku.cost) return;

        const request = {
            seller_id: 'SELF',
            seller_sku: new_sku.seller_sku,
            category: new_sku.category,
            cost: parseFloat(new_sku.cost),
            is_active: new_sku.is_active,
            fn_sku: new_sku.fn_sku || null,
            asin: new_sku.asin || null,
            product_name: new_sku.product_name || null,
            comment: new_sku.comment || null,
        };

        this.setState({ add_sku_submitting: true });

        generic_post_api(request, SKU_METADATA)
        .then(() => {
            this.setState({
                show_add_sku_modal: false,
                add_sku_submitting: false,
                show_success_modal: true,
            });
            this.fetchSkuList();
        })
        .catch(error => {
            this.setState({ add_sku_submitting: false });
        });
    }

    confirmDeleteSku(sku) {
        this.setState({ show_delete_modal: true, delete_sku: sku });
    }

    deleteSku() {
        const { delete_sku } = this.state;
        if (!delete_sku) return;

        this.setState({ deleting: true });

        generic_delete_api(SKU_METADATA, { seller_id: 'SELF', seller_sku: delete_sku.seller_sku })
        .then(() => {
            this.setState({ show_delete_modal: false, delete_sku: null, deleting: false });
            this.fetchSkuList();
        })
        .catch(error => {
            this.setState({ deleting: false });
        });
    }

    openAddDataModal(sku) {
        this.setState({
            show_add_data_modal: true,
            add_data_sku: {
                seller_sku: sku.seller_sku,
                category: sku.category || '',
                cost: sku.cost != null ? sku.cost : '',
                is_active: sku.is_active,
                fn_sku: sku.fn_sku || '',
                asin: sku.asin || '',
                product_name: sku.product_name || '',
                comment: sku.comment || '',
            },
        });
    }

    updateAddDataField(field, value) {
        this.setState({ add_data_sku: { ...this.state.add_data_sku, [field]: value } });
    }

    submitAddData() {
        const { add_data_sku } = this.state;
        if (!add_data_sku.category || !add_data_sku.cost) return;

        const request = {
            seller_id: 'SELF',
            seller_sku: add_data_sku.seller_sku,
            category: add_data_sku.category,
            cost: parseFloat(add_data_sku.cost),
            is_active: add_data_sku.is_active,
            fn_sku: add_data_sku.fn_sku || null,
            asin: add_data_sku.asin || null,
            product_name: add_data_sku.product_name || null,
            comment: add_data_sku.comment || null,
        };

        this.setState({ add_data_submitting: true });

        generic_patch_api(SKU_METADATA, request)
        .then(() => {
            this.setState({
                show_add_data_modal: false,
                add_data_submitting: false,
                add_data_sku: null,
            });
            this.fetchSkuList();
        })
        .catch(error => {
            this.setState({ add_data_submitting: false });
        });
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, { 'data_1': 'sku_metadata_list' });
        this.fetchSkuList();
        this._handleClickOutside = (e) => {
            if (this.state.show_category_dropdown && this._categoryDropdownRef && !this._categoryDropdownRef.contains(e.target)) {
                this.setState({ show_category_dropdown: false });
            }
        };
        document.addEventListener('mousedown', this._handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._handleClickOutside);
    }

    render() {
        const { filtered_sku_list, search_string, loading, show_full_product_name, new_sku } = this.state;

        return (
            <div class="container mt-4" style={{ maxWidth: '1100px' }}>
                <h4 class="mb-3">SKU Management</h4>

                <div class="mb-4">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Search by SKU or product name"
                        value={search_string}
                        onChange={(e) => this.applyFilters(e.target.value)}
                    />
                </div>

                <div class="mb-4 d-flex gap-4 align-items-center">
                    <select class="form-select form-select-sm" style={{ width: 'auto' }}
                        value={this.state.status_filter}
                        onChange={(e) => this.applyFilters(undefined, e.target.value)}>
                        <option value="all">All</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                    <div class="position-relative" ref={el => this._categoryDropdownRef = el}>
                        <button class="btn btn-sm btn-outline-secondary" onClick={() => this.setState({ show_category_dropdown: !this.state.show_category_dropdown })}>
                            Category {this.state.selected_categories.length < SKU_CATEGORIES.length ? `(${this.state.selected_categories.length})` : '(All)'} <i class="fa-solid fa-caret-down ms-1"></i>
                        </button>
                        {this.state.show_category_dropdown &&
                            <div class="position-absolute bg-white border rounded shadow-sm p-2 mt-1" style={{ zIndex: 1050, width: '200px', maxHeight: '300px', overflowY: 'auto' }}>
                                <div class="form-check mb-1">
                                    <input type="checkbox" class="form-check-input" id="catAll"
                                        checked={this.state.selected_categories.length === SKU_CATEGORIES.length}
                                        onChange={() => this.toggleAllCategories()} />
                                    <label class="form-check-label fw-bold" htmlFor="catAll">All</label>
                                </div>
                                <hr class="my-1" />
                                {SKU_CATEGORIES.map(cat => (
                                    <div class="form-check mb-1" key={cat.value}>
                                        <input type="checkbox" class="form-check-input" id={'cat-' + cat.value}
                                            checked={this.state.selected_categories.includes(cat.value)}
                                            onChange={() => this.toggleCategory(cat.value)} />
                                        <label class="form-check-label" htmlFor={'cat-' + cat.value}>{cat.label}</label>
                                    </div>
                                ))}
                                <hr class="my-1" />
                                <a href="#" class="small text-muted" onClick={(e) => { e.preventDefault(); this.applyFilters(undefined, undefined, []); }}>Deselect all</a>
                            </div>
                        }
                    </div>
                    <div class="form-check">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="showFullProductName"
                            checked={this.state.show_full_product_name}
                            onChange={(e) => this.setState({ show_full_product_name: e.target.checked })}
                        />
                        <label class="form-check-label" htmlFor="showFullProductName">Full product name</label>
                    </div>
                    <button class="btn btn-primary btn-sm ms-auto" onClick={() => this.openAddSkuModal()}>+ Add SKU</button>
                </div>

                {loading &&
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={12} size="lg" className="mb-2" />
                        <Placeholder xs={12} size="lg" className="mb-2" />
                        <Placeholder xs={12} size="lg" className="mb-2" />
                    </Placeholder>
                }

                {!loading && filtered_sku_list.length === 0 &&
                    <div class="text-muted mt-3">No SKUs found.</div>
                }

                {!loading && filtered_sku_list.length > 0 &&
                    <div class="small border rounded py-3" style={{ overflow: 'hidden' }}>
                        <div class="row fw-bold border-bottom pb-2 px-3">
                            <div class="col-auto">&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div class="col-3">SKU / ASIN / FN_SKU</div>
                            <div class="col-1">Category</div>
                            <div class="col-4">Product Name</div>
                            <div class="col-1">COGS</div>
                            <div class="col-2">Actions</div>
                        </div>
                        {filtered_sku_list.map((sku, idx) => (
                            <div class="row py-2 px-3 border-bottom align-items-center" style={idx % 2 === 0 ? { backgroundColor: '#eef4f1' } : {}} key={sku.seller_sku + '-' + idx}>
                                <div class="col-auto">
                                    {sku.is_active
                                        ? <i class="fa-solid fa-eye" style={{ color: 'hsl(152, 69%, 31%)' }}></i>
                                        : <i class="fa-solid fa-eye" style={{ color: '#c73110' }}></i>
                                    }
                                </div>
                                <div class="col-3">
                                    <div class="fw-semibold">{sku.seller_sku}</div>
                                    <div class="text-muted">{sku.asin || '—'}</div>
                                    <div class="text-muted">{sku.fn_sku || '—'}</div>
                                </div>
                                <div class="col-1">{(SKU_CATEGORIES.find(c => c.value === sku.category) || {}).label || sku.category || <span class="text-muted">—</span>}</div>
                                <div class="col-4">
                                    {sku.product_name
                                        ? (show_full_product_name || sku.product_name.length <= 60
                                            ? sku.product_name
                                            : sku.product_name.substring(0, 40) + '...')
                                        : <span class="text-muted">—</span>
                                    }
                                </div>
                                <div class="col-1">{sku.cost != null ? '$' + sku.cost.toFixed(2) : <span class="text-muted">—</span>}</div>
                                <div class="col-2">
                                    <div><button class="btn btn-sm btn-outline-primary" onClick={() => this.openAddDataModal(sku)}>+ Add data</button></div>
                                    <div class="mt-1">
                                        <a href="#" class="link-primary me-3" onClick={(e) => { e.preventDefault(); this.props.history.push({ pathname: '/amz/sku_metadata', state: { seller_sku: sku.seller_sku, asin: sku.asin, fn_sku: sku.fn_sku } }); }}>History</a>
                                        <a href="#" class="text-danger" onClick={(e) => { e.preventDefault(); this.confirmDeleteSku(sku); }}>
                                            <i class="fa-regular fa-trash-can"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }

                {/* Add SKU Modal */}
                <Modal show={this.state.show_add_sku_modal} onHide={() => this.closeAddSkuModal()} size="md">
                    <Modal.Header closeButton>
                        <Modal.Title>Add SKU</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label class="form-label">SKU <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" value={new_sku.seller_sku}
                                    onChange={(e) => this.updateNewSkuField('seller_sku', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">FN SKU</label>
                                <input type="text" class="form-control" value={new_sku.fn_sku}
                                    onChange={(e) => this.updateNewSkuField('fn_sku', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">ASIN</label>
                                <input type="text" class="form-control" value={new_sku.asin}
                                    onChange={(e) => this.updateNewSkuField('asin', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">Category <span class="text-danger">*</span></label>
                                <select class="form-select" value={new_sku.category}
                                    onChange={(e) => this.updateNewSkuField('category', e.target.value)}>
                                    <option value="">Select category</option>
                                    {SKU_CATEGORIES.map(cat => (
                                        <option key={cat.value} value={cat.value}>{cat.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">COGS <span class="text-danger">*</span></label>
                                <input type="number" step="0.01" class="form-control" value={new_sku.cost}
                                    onChange={(e) => this.updateNewSkuField('cost', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">Status <span class="text-danger">*</span></label>
                                <div class="d-flex gap-3 mt-1">
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" name="skuStatus" id="statusActive"
                                            checked={new_sku.is_active === true}
                                            onChange={() => this.updateNewSkuField('is_active', true)} />
                                        <label class="form-check-label" htmlFor="statusActive">Active</label>
                                    </div>
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" name="skuStatus" id="statusInactive"
                                            checked={new_sku.is_active === false}
                                            onChange={() => this.updateNewSkuField('is_active', false)} />
                                        <label class="form-check-label" htmlFor="statusInactive">Inactive</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Product Name</label>
                            <input type="text" class="form-control" value={new_sku.product_name}
                                onChange={(e) => this.updateNewSkuField('product_name', e.target.value)} />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Comment</label>
                            <textarea class="form-control" rows="2" value={new_sku.comment}
                                onChange={(e) => this.updateNewSkuField('comment', e.target.value)} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button class="btn btn-secondary" onClick={() => this.closeAddSkuModal()}>Cancel</button>
                        <button class="btn btn-primary"
                            disabled={!new_sku.seller_sku || !new_sku.category || !new_sku.cost || this.state.add_sku_submitting}
                            onClick={() => this.submitAddSku()}>
                            {this.state.add_sku_submitting ? 'Adding...' : 'Add SKU'}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={this.state.show_delete_modal} onHide={() => this.setState({ show_delete_modal: false, delete_sku: null })} size="sm" centered>
                    <Modal.Body class="py-4">
                        <div class="mb-3">Are you sure you want to delete SKU <span class="fw-bold">{this.state.delete_sku?.seller_sku}</span>?</div>
                        <div class="d-flex justify-content-end gap-2">
                            <button class="btn btn-secondary btn-sm" onClick={() => this.setState({ show_delete_modal: false, delete_sku: null })}>Cancel</button>
                            <button class="btn btn-danger btn-sm" disabled={this.state.deleting} onClick={() => this.deleteSku()}>
                                {this.state.deleting ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Add Data Modal */}
                <Modal show={this.state.show_add_data_modal} onHide={() => this.setState({ show_add_data_modal: false, add_data_sku: null })} size="md">
                    <Modal.Header closeButton>
                        <Modal.Title>Add Data</Modal.Title>
                    </Modal.Header>
                    {this.state.add_data_sku &&
                    <Modal.Body>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label class="form-label">SKU</label>
                                <input type="text" class="form-control" value={this.state.add_data_sku.seller_sku} disabled />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">FN SKU</label>
                                <input type="text" class="form-control" value={this.state.add_data_sku.fn_sku}
                                    onChange={(e) => this.updateAddDataField('fn_sku', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">ASIN</label>
                                <input type="text" class="form-control" value={this.state.add_data_sku.asin}
                                    onChange={(e) => this.updateAddDataField('asin', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">Category <span class="text-danger">*</span></label>
                                <select class="form-select" value={this.state.add_data_sku.category}
                                    onChange={(e) => this.updateAddDataField('category', e.target.value)}>
                                    <option value="">Select category</option>
                                    {SKU_CATEGORIES.map(cat => (
                                        <option key={cat.value} value={cat.value}>{cat.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">COGS <span class="text-danger">*</span></label>
                                <input type="number" step="0.01" class="form-control" value={this.state.add_data_sku.cost}
                                    onChange={(e) => this.updateAddDataField('cost', e.target.value)} />
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label">Status</label>
                                <div class="d-flex gap-3 mt-1">
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" name="addDataStatus" id="addDataActive"
                                            checked={this.state.add_data_sku.is_active === true}
                                            onChange={() => this.updateAddDataField('is_active', true)} />
                                        <label class="form-check-label" htmlFor="addDataActive">Active</label>
                                    </div>
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" name="addDataStatus" id="addDataInactive"
                                            checked={this.state.add_data_sku.is_active === false}
                                            onChange={() => this.updateAddDataField('is_active', false)} />
                                        <label class="form-check-label" htmlFor="addDataInactive">Inactive</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Product Name</label>
                            <input type="text" class="form-control" value={this.state.add_data_sku.product_name}
                                onChange={(e) => this.updateAddDataField('product_name', e.target.value)} />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Comment</label>
                            <textarea class="form-control" rows="2" value={this.state.add_data_sku.comment}
                                onChange={(e) => this.updateAddDataField('comment', e.target.value)} />
                        </div>
                    </Modal.Body>
                    }
                    <Modal.Footer>
                        <button class="btn btn-secondary" onClick={() => this.setState({ show_add_data_modal: false, add_data_sku: null })}>Cancel</button>
                        <button class="btn btn-primary"
                            disabled={!this.state.add_data_sku?.category || !this.state.add_data_sku?.cost || this.state.add_data_submitting}
                            onClick={() => this.submitAddData()}>
                            {this.state.add_data_submitting ? 'Saving...' : 'Add new data'}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* Success Modal */}
                <Modal show={this.state.show_success_modal} onHide={() => this.setState({ show_success_modal: false })} size="sm" centered>
                    <Modal.Body class="text-center py-4">
                        <div class="mb-2 text-success fw-bold">SKU added successfully</div>
                        <button class="btn btn-primary btn-sm" onClick={() => this.setState({ show_success_modal: false })}>OK</button>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default SkuMetadataList;
